import { downloadSvgImage, loadGifImage, loadImage } from "./Utils";
import { ImageDrawer } from "./ImageDrawer";
import { ImagePreloaderPlugin } from "./ImagePreloader";
import { errorPrefix } from "tsparticles-engine";
function addLoadImageToEngine(engine) {
  if (engine.loadImage) {
    return;
  }
  engine.loadImage = async data => {
    if (!data.name && !data.src) {
      throw new Error("".concat(errorPrefix, " no image source provided"));
    }
    if (!engine.images) {
      engine.images = [];
    }
    if (engine.images.find(t => t.name === data.name || t.source === data.src)) {
      return;
    }
    try {
      var _data$gif, _data$name;
      const image = {
        gif: (_data$gif = data.gif) !== null && _data$gif !== void 0 ? _data$gif : false,
        name: (_data$name = data.name) !== null && _data$name !== void 0 ? _data$name : data.src,
        source: data.src,
        type: data.src.substring(data.src.length - 3),
        error: false,
        loading: true,
        replaceColor: data.replaceColor,
        ratio: data.width && data.height ? data.width / data.height : undefined
      };
      engine.images.push(image);
      const imageFunc = data.gif ? loadGifImage : data.replaceColor ? downloadSvgImage : loadImage;
      await imageFunc(image);
    } catch {
      var _data$name2;
      throw new Error("".concat(errorPrefix, " ").concat((_data$name2 = data.name) !== null && _data$name2 !== void 0 ? _data$name2 : data.src, " not found"));
    }
  };
}
export async function loadImageShape(engine) {
  let refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  addLoadImageToEngine(engine);
  const preloader = new ImagePreloaderPlugin(engine);
  await engine.addPlugin(preloader, refresh);
  await engine.addShape(["image", "images"], new ImageDrawer(engine), refresh);
}